import { i18n } from "../translate/i18n";

export const PROMPT_TYPES = ["text", "voice", "specialist"];

const typesOf = (types) => (Array.isArray(types) ? types : [types]);

export const isPromptOfType = (prompt, types) => typesOf(types).includes(prompt?.type || "text");

export const promptsOfType = (prompts, types, selectedId) =>
  (prompts || []).filter(
    (prompt) =>
      isPromptOfType(prompt, types) ||
      (selectedId !== null && selectedId !== undefined && selectedId !== "" && String(prompt.id) === String(selectedId))
  );

export const promptOptionLabel = (prompt, types) =>
  isPromptOfType(prompt, types)
    ? prompt.name
    : `${prompt.name} (${i18n.t(`prompts.types.${prompt.type || "text"}`)} · ${i18n.t("prompts.wrongTypeHint")})`;
